/** This browser's four most recently viewed product IDs, newest first. */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  static addProduct(productId) {
    const id = String(productId);
    if (!/^\d+$/.test(id)) return;
    const products = [id, ...this.getProducts().filter(value => value !== id)].slice(0, this.#MAX_PRODUCTS);
    try { localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(products)); } catch { /* Storage can be disabled. */ }
  }

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch { /* No stored history to clear. */ }
  }

  static getProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      return [...new Set(stored.map(String).filter(id => /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS);
    } catch { return []; }
  }
}
